<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

/**
 * Stores
 */
const gameStore = useGameStore();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.player!.profileImage"
    :toast-text="t('news.types.spyShipSabotaged.title')"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="gameStore.player!.profileImage"
      :header="t('news.types.spyShipSabotaged.title')"
    >
      <div>
        {{ t('news.types.spyShipSabotaged.body', { count: props.newsItem.contentData.destroyed ?? 1 }) }}
        <template v-for="(shipName, index) in props.newsItem.contentData.ships" :key="index">
          <span class="text-metal-300">
            <template v-if="index > 0">, </template>{{ shipName }}
          </span>
        </template>
      </div>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>